// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --oc-min-h: 36px;
    /* súbelo a 38–40px si quieres más alto */
    --oc-fs: 14px;
}

/* Controles: sin altura fija, con padding contenido */
.oc-control .Input,
.oc-control select,
.oc-control input[type="datetime-local"] {
    width: 100%;
    height: auto;
    /* <- importante */
    min-height: var(--oc-min-h);
    /* altura mínima coherente */
    padding: 4px 10px;
    /* menos padding vertical */
    font-size: var(--oc-fs);
    line-height: 1.2;
    /* evita el recorte del texto */
    box-sizing: border-box;
}

/* Textarea aparte */
.oc-control textarea {
    width: 100%;
    min-height: 155px;
    padding: 6px 10px;
    font-size: var(--oc-fs);
    line-height: 1.3;
    box-sizing: border-box;
}

/* Placeholder gris solo cuando no hay valor */
.oc-select {
    color: #111;
}

.oc-select:invalid {
    color: #6b7280;
    font-style: normal;
}

.oc-select option {
    color: #111;
}

.oc-select option[disabled][value=""] {
    color: #9ca3af;
}

.oc-control textarea,
textarea.TextAreaReportSe {
    text-align: left !important;
    direction: ltr;
    /* por si acaso */
}

.oc-search-select__control,
.oc-search-select__input-container,
.oc-search-select__single-value,
.oc-search-select__placeholder {
    font-style: normal;
}

.oc-modern-card {
    border: 1px solid #d7e5f3;
    border-radius: 14px;
    background: linear-gradient(180deg, #fbfdff 0%, #f3f8fe 100%);
    padding: 14px 10px 8px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.oc-modern-card .Label {
    font-weight: 700;
    color: #1e293b;
}

.oc-modern-card .oc-control .Input,
.oc-modern-card .oc-control .oc-select,
.oc-modern-card .oc-control textarea,
.oc-modern-card .oc-control textarea.TextAreaReportSe {
    border: 1px solid #cfe0f0 !important;
    border-radius: 4px;
    background: #fff;
    box-shadow: none !important;
    outline: none;
}

.oc-modern-card .oc-control .Input:focus,
.oc-modern-card .oc-control textarea:focus {
    border-color: #86b7fe !important;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.2) !important;
}

.oc-modern-actions {
    margin-top: 8px !important;
}

.oc-modern-primary-btn {
    border-radius: 10px !important;
    background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%) !important;
    border: 0 !important;
    font-weight: 700 !important;
}

.oc-modern-secondary-btn {
    border-radius: 10px !important;
    border: 1px solid #c6d6e8 !important;
    background: #f8fbff !important;
    color: #4b647d !important;
    font-weight: 700 !important;
}

.oc-modern-table-card {
    border: 1px solid #d7e5f3 !important;
    border-radius: 12px !important;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
    overflow: hidden;
}

.oc-modern-table-responsive {
    width: 100%;
    max-width: 100%;
    display: block !important;
    overflow-x: auto;
    overflow-y: auto;
}

.oc-modern-table-inner {
    width: 100% !important;
    min-width: 1280px;
    margin-bottom: 0;
}

.oc-modern-table-card tbody tr:hover {
    background: #edf6ff;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/ordenesCompras.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;AACjB;;AAEA,sDAAsD;AACtD;;;IAGI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,8CAA8C;AAC9C;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6DAA6D;IAC7D,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;;IAII,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;;IAEI,gCAAgC;IAChC,2DAA2D;AAC/D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,wEAAwE;IACxE,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[":root {\n    --oc-min-h: 36px;\n    /* súbelo a 38–40px si quieres más alto */\n    --oc-fs: 14px;\n}\n\n/* Controles: sin altura fija, con padding contenido */\n.oc-control .Input,\n.oc-control select,\n.oc-control input[type=\"datetime-local\"] {\n    width: 100%;\n    height: auto;\n    /* <- importante */\n    min-height: var(--oc-min-h);\n    /* altura mínima coherente */\n    padding: 4px 10px;\n    /* menos padding vertical */\n    font-size: var(--oc-fs);\n    line-height: 1.2;\n    /* evita el recorte del texto */\n    box-sizing: border-box;\n}\n\n/* Textarea aparte */\n.oc-control textarea {\n    width: 100%;\n    min-height: 155px;\n    padding: 6px 10px;\n    font-size: var(--oc-fs);\n    line-height: 1.3;\n    box-sizing: border-box;\n}\n\n/* Placeholder gris solo cuando no hay valor */\n.oc-select {\n    color: #111;\n}\n\n.oc-select:invalid {\n    color: #6b7280;\n    font-style: normal;\n}\n\n.oc-select option {\n    color: #111;\n}\n\n.oc-select option[disabled][value=\"\"] {\n    color: #9ca3af;\n}\n\n.oc-control textarea,\ntextarea.TextAreaReportSe {\n    text-align: left !important;\n    direction: ltr;\n    /* por si acaso */\n}\n\n.oc-search-select__control,\n.oc-search-select__input-container,\n.oc-search-select__single-value,\n.oc-search-select__placeholder {\n    font-style: normal;\n}\n\n.oc-modern-card {\n    border: 1px solid #d7e5f3;\n    border-radius: 14px;\n    background: linear-gradient(180deg, #fbfdff 0%, #f3f8fe 100%);\n    padding: 14px 10px 8px;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n}\n\n.oc-modern-card .Label {\n    font-weight: 700;\n    color: #1e293b;\n}\n\n.oc-modern-card .oc-control .Input,\n.oc-modern-card .oc-control .oc-select,\n.oc-modern-card .oc-control textarea,\n.oc-modern-card .oc-control textarea.TextAreaReportSe {\n    border: 1px solid #cfe0f0 !important;\n    border-radius: 4px;\n    background: #fff;\n    box-shadow: none !important;\n    outline: none;\n}\n\n.oc-modern-card .oc-control .Input:focus,\n.oc-modern-card .oc-control textarea:focus {\n    border-color: #86b7fe !important;\n    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.2) !important;\n}\n\n.oc-modern-actions {\n    margin-top: 8px !important;\n}\n\n.oc-modern-primary-btn {\n    border-radius: 10px !important;\n    background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%) !important;\n    border: 0 !important;\n    font-weight: 700 !important;\n}\n\n.oc-modern-secondary-btn {\n    border-radius: 10px !important;\n    border: 1px solid #c6d6e8 !important;\n    background: #f8fbff !important;\n    color: #4b647d !important;\n    font-weight: 700 !important;\n}\n\n.oc-modern-table-card {\n    border: 1px solid #d7e5f3 !important;\n    border-radius: 12px !important;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n    overflow: hidden;\n}\n\n.oc-modern-table-responsive {\n    width: 100%;\n    max-width: 100%;\n    display: block !important;\n    overflow-x: auto;\n    overflow-y: auto;\n}\n\n.oc-modern-table-inner {\n    width: 100% !important;\n    min-width: 1280px;\n    margin-bottom: 0;\n}\n\n.oc-modern-table-card tbody tr:hover {\n    background: #edf6ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
